<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'informes' }">{{ $t("informes") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'pedidos-repartidores' }">{{
                                $t("pedidosPorRepartidores") }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{ $t("listadoTicketRepartidor") }}</li>
                        <span v-if="workerName">&nbsp;&nbsp; :&nbsp; {{ workerName.toUpperCase() }}</span>
                    </ol>
                </nav>
            </div>
            <CabeceraInformes :idBusiness="idBusiness" :listBusinesses="listBusinesses" :idTpv="idTpv" :dateto="dateto"
                :datefrom="datefrom" id="cabecera" :conTodos="true" />
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>


            <div class="col-12">

                <div v-if="ticketsList && ticketsList.length > 0">
                    <div v-for="ticket in ticketsList" :key="ticket.id">
                        <ticket :ticket="ticket"></ticket>
                    </div>
                </div>
                <div v-else class="alert alert-danger" style="width: 100%" role="alert">
                    <p>No hay tickets disponibles.</p>
                </div>

            </div>

        </div>
    </div>
</template>

<script>


import Datetime from "vue-datetime";


import {
    Button,
    ButtonGroup,
    Checkbox,
    CheckboxGroup,
    DatePicker,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Option,
    Select,
    Loading,
    Switch
} from "element-ui";
import swal from "sweetalert2";
import { mapState, mapMutations } from 'vuex';
import moment from "moment";
import CabeceraInformes from "../../../../components/CabeceraInformes/CabeceraInformes";
import Terms from "../../../GeneralViews/Terms";
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb.vue";
import Ticket from "../../../Widgets/Ticket.vue";
import PedidosRepartidores from './PedidosRepartidores.vue';

export default {

    created() {
        this.loading = Loading.service({ text: this.$t('cargando') });
        this.$store.dispatch("setNameRoute", this.$i18n.t("listadoTicketRepartidor"));
        this.getBusiness();
        this.idRepartidor = this.$route.params.idRepartidor;
        this.workerName = this.$route.params.workerName;
        this.idTpv = this.$route.params.idTpv;
        this.datefrom = this.$route.params.datefrom;
        this.dateto = this.$route.params.dateto;
        this.idBusiness = this.$route.params.idBusiness;
       
        if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
            this.datefrom = this.$store.getters.dateFrom;
            this.dateto = this.$store.getters.dateTo;
        }

    },
    mounted() {
        this.getDeliveryTickets();
    },

    components: {
        Terms,
        //CabeceraRepartidores,
        PedidosRepartidores,
        CabeceraInformes,
        Ticket,
        [DatePicker.name]: DatePicker,
        [Select.name]: Select,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
        [Option.name]: Option,
        [Checkbox.name]: Checkbox,
        [CheckboxGroup.name]: CheckboxGroup,
        [Datetime.name]: Datetime,
        [ButtonGroup.name]: ButtonGroup,
        [Switch.name]: Switch,
        //TicketsRepartidor,
        Breadcrumb,
    },

    data() {
        return {
            loading: false,

            TicketsRepartidor: [],
            hoursfrom: "00:00:00",
            hoursto: "23:59:59",
            listBusinesses: [],
            listCompanies: [],
            idCompany: 0,
            data: [""],
            listTpv: [],
            idRepartidor: null,
            workerName: "",

            // idTpv: -1,
            value4: [
                new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                new Date(),
            ],
            cuentasAparcadas: false,
            dateInform: [],
            dateRangeOptions1Comercial: {
                firstDayOfWeek: 1,
            },
            tabs: 'TicketsRepartidor', // Inicializa con un valor por defecto
            idDay: 0, // O un valor por defecto
            idTpv: null,
            observar: 0,
            idsTPV: [],
            listCheckBoxTpv: [],

            openDay: false,
            tabs: "Cierre",

            respuesta: false,
            filterSelected: 0,

            listMesasSales: [],

            despachos: false,
            dimoni: false,
            consultarInicioCuenta: false,
            porHoras: "",
            agrupacionPorEmpresa: false,

            filter: 0,
            filterTag: [
                { value: 0, label: this.$t('todos') },
                { value: 1, label: this.$t('socios') },
                { value: 2, label: this.$t('noSocios') },
                { value: 3, label: this.$t('empresa') }
            ],
            ventasAgrupadas: [],
            tickets: [],
            ticketsList: [],
        };
    },

    watch: {

        emitirConsulta() {

            this.getDeliveryTickets();

        },

    },
    computed: {
        ...mapState(["listaSectores", "sectores", "permiso"]),


    },
    methods: {
        emitirConsulta() {

            this.getDeliveryTickets();

        },

        getBusiness() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                .then(function (response) {

                    vm.listBusinesses = response.data.result;
                    if (vm.$store.getters.idBusiness) {
                        vm.idBusiness = vm.$store.getters.idBusiness;
                    } else {

                        vm.idBusiness = response.data.result[0].id;
                    }

                    vm.getTpv();

                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getDeliveryTickets() {

            if (!this.datefrom || !this.dateto) {
                swal({
                    title: this.$t('ups'),
                    text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });
                return; // Salir de la función
            }
            let secondsDesde = moment(this.datefrom).startOf("day").unix();
            let secondsHasta = moment(this.dateto).endOf("day").unix();
            if (secondsHasta < secondsDesde) {
                swal({
                    title: this.$t('ups'),
                    text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });
                return;
            }


            let idTpvAMandar = this.idTpv === -1 ? 0 : this.idTpv;
            let config = {
                params: {
                    idBusiness: this.idBusiness,
                    idTpv: idTpvAMandar,
                    datefrom: secondsDesde,
                    dateto: secondsHasta,
                    idWorker: this.idRepartidor,
                    jwt: this.$store.getters.jwt,
                    desde: 1

                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };
            let vm = this;
            vm.repartidorId = this.idRepartidor;
            this.axios.get(this.$store.getters.apiUrl + "workers/getTicketList", config)

                .then(function (response) {

                    if (response.data.response) {

                        if (Array.isArray(response.data.result.tickets)) {
                            vm.ticketsList = response.data.result.tickets;

                        } else if (typeof response.data.result === 'object' && response.data.result !== null) {
                            vm.ticketsList = Object.values(response.data.result);

                        } else {
                            console.log("No es un array.");
                        }
                        vm.respuesta = true;


                    } else if (response.data.response == false && response.data.rangoMayor) {
                        swal({
                            title: "Lo sentimos",
                            text: response.data.result,
                            confirmButtonClass: "btn btn-info btn-fill",
                            type: "info",
                        });
                        this.respuesta = false;
                    } else {
                        swal({
                            title: vm.$t('accesoDenegado'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                        vm.respuesta = false;
                    }
                })
                .catch(error => {
                    console.error("Error de la API:", error.response ? error.response.data : error.message);
                    swal({
                        title: this.$t('error'),
                        text: error.response ? error.response.data.message : this.$t('errorConexion'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                })
                .finally(() => {
                    if (this.respuesta) {
                        this.loading.close();
                    }
                });

        },

        ...mapMutations(['changeListaSectores']),
        styleCheckFilter(filterSelected) {
            return this.filterSelected == filterSelected;
        },


        checkConfigCompany() {
            this.agrupacionPorEmpresa = false;

            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/checkConfigCompanyAgrupation", config)
                .then(function (response) {
                    if (response.data.response) {

                        if (response.data.result.config) {
                            vm.agrupacionPorEmpresa = true;
                            vm.listCompanies = response.data.result.listCompanies;
                            vm.idCompany = vm.listCompanies[0].id;

                            vm.getBusinessesByCompany();
                        } else {
                            vm.getBusiness();
                        }


                    } else {
                        vm.loading.close();
                    }

                }).catch(function (error) {
                    console.log(error);
                })
        },
        cambioSector(idSectorData, listBusinesses) {

            if (listBusinesses) {
                this.listBusinesses = listBusinesses;
            }

            this.idSector = idSectorData;
            this.idBusiness = -1;
            this.getAllTpvFromBusinesses();
        },
        //CABECERAS
        cambioBusiness(idBusinessData, listTpv) {
            if (listTpv) {
                this.listTpv = listTpv;
            }
            this.loading = Loading.service({ text: "Cargando..." });
            this.idBusiness = idBusinessData;

            this.idTpv = -1;
            this.idsTPV = [];

            if (
                ((!this.sectores && !this.$cookies.isKey("sectores")) && idBusinessData != -1)
                || this.sectores && this.$cookies.isKey("sectores") && idBusinessData != -1
            ) {
                this.getTpv();
            } else {
                this.getAllTpvFromBusinesses();
            }

        },
        cambioCompany(idCompanyData, listBusinesses) {
            if (listBusinesses) {
                this.listBusinesses = listBusinesses;
            }
            this.loading = Loading.service({ text: "Cargando..." });
            this.idCompany = idCompanyData;

            this.idBusiness = -1;
            this.idTpv = -1;

            this.getBusinessesByCompany();

        },

        cambioTpv(idTpvData, filtrar) {
            if (idTpvData != undefined) {
                this.idTpv = idTpvData;
                this.changeTPV();
            }

            this.idTpv = idTpvData;
            this.emitirConsulta();
        },
        cambioHora(dates) {
            this.datefrom = dates[0];
            this.dateto = dates[1];
        },

        getAmount(obj) {
            return obj.amount ? obj.amount : obj.money;
        },

        openModal() {
            this.$modal.show("filtradoTPV");
        },

        // handleTabChange(tabIndex, newTab, oldTab) {
        //     this.tabs = newTab.title;
        //     if (this.tabs == "Volver") {
        //         this.openDay = false;
        //         this.idDay = 2694352;
        //     }
        // },
        hasSageDespacho() {
            if (this.idBusiness.length > 0) {
                var config = {
                    params: {
                        idTpv: this.listTpv[0].id,
                        numConfig: '73',
                        jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
                    .then(function (response) {
                        if (response.data.response == true) {
                            vm.despachos = true;
                        } else {
                            vm.despachos = false;
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
            }
        },
        hasDimoni() {
            if (this.idBusiness.length > 0) {
                var config = {
                    params: {
                        idTpv: this.listTpv[0].id,
                        numConfig: '83',
                        jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
                    .then(function (response) {
                        if (response.data.response == true) {
                            vm.dimoni = true;
                        } else {
                            vm.dimoni = false;
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
            }
        },

        getAllTpvFromBusinesses() {
            let businesses = [];

            this.listBusinesses.forEach(business => {

                if (business.id != -1) {
                    businesses.push(parseInt(business.id));
                }

            });

            let config = {
                params: {
                    jwt: this.$store.getters.jwt,
                    idBusiness: businesses,
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByListBusiness", config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.listTpv = [];
                        vm.idsTPV = [];

                        for (let i = 0; i < response.data.result.length; i++) {
                            vm.idsTPV.push(response.data.result[i].id);
                        }

                        vm.listCheckBoxTpv = response.data.result;

                        for (let i = 0; i < response.data.result.length; i++) {
                            let printername = {
                                nameShow: response.data.result[i].nameShow,
                                id: response.data.result[i].id,
                            };

                            vm.listTpv.push(printername);
                        }
                    }
                    vm.loading.close();

                }).catch(function (error) {
                    console.log(error);
                })
        },

        getBusinessesByCompany() {

            this.listBusinesses = [];

            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                    idCompany: this.idCompany,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.axios
                .get(this.$store.getters.apiUrl + "general/getBusinessesByCompany", config)
                .then(function (response) {

                    let printername = {
                        establishmentName: "Todos",
                        id: -1,
                    };

                    vm.listBusinesses.push(printername);

                    response.data.result.forEach(result => {
                        vm.listBusinesses.push(result);
                    });
                    //vm.listBusinesses = response.data.result;
                    vm.idBusiness = -1;
                    vm.getAllTpvFromBusinesses();
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getTpv() {
            this.listTpv = [];
            this.idsTPV = [];
            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.axios
                .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.listTpv = [];
                        vm.idsTPV = [];

                        for (let i = 0; i < response.data.result.length; i++) {
                            vm.idsTPV.push(response.data.result[i].id);
                        }

                        //vm.idTpv = response.data.result[0].id;

                        vm.listCheckBoxTpv = response.data.result;

                        for (let i = 0; i < response.data.result.length; i++) {
                            let printername = {
                                nameShow: response.data.result[i].nameShow,
                                id: response.data.result[i].id,
                            };

                            vm.listTpv.push(printername);
                        }

                        vm.hasSageDespacho();
                        vm.hasDimoni();
                        vm.grafica = 0;
                    }
                    vm.loading.close();
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        changeTPV() {
            if (this.idTpv === -1) {
                this.idsTPV = [];

                for (let i = 0; i < this.listTpv.length; i++) {
                    this.idsTPV.push(this.listTpv[i].id);
                }
            } else {
                this.idsTPV = [];
                this.idsTPV.push(this.idTpv);
            }
        },

    },
};

</script>

<style scoped>
.consultarSwitch {
    padding-top: 6px;
}

.el-switch {
    margin: 6px;
    margin-bottom: 5px;
}

.active-filter {
    color: #1E22AA;
    border-color: #b9d0d7;
    background-color: #e8eff2;
}

.active-filter-mesas {
    background-color: #f38a09;
    border-color: #b9d0d7;
}

a li {
    color: #111;
}

.card {
    padding: 20px;
}

.div-export {
    margin-bottom: 10px;
}

.sunday {
    color: rgb(128, 0, 0);
}

.fridaySaturday {
    color: rgb(0, 128, 64);
}

.trDay:hover {
    background-color: rgba(68, 125, 247, 0.2) !important;
}

.justify-content-right {
    margin-left: 15px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Pedidos/ListadoTicketRepartidor.vue